import React from "react";
import {
  ReceiptAndPaymentGstReceivableType,
  ReceiptAndPaymentReceiptOpeningBalanceType,
  ReceiptAndPaymentReceiptOtherType,
  ReceiptAndPaymentRevenuesDetailsType,
  ReceiptAndPaymentRevenuesType,
  ReceiptAndPaymentTDSDataType,
  ReceiptAndPaymentType,
} from "../../../../redux/reports/reportsType";
import { TableHeadersType } from "../../../../constant/tableHeadersConstants/tableHeadersType";
import { currencySignAndNegativeValueAdjust } from "../../../../utils/commonFunctions";

type AppProps = {
  tableHeaders: TableHeadersType[];
  data: ReceiptAndPaymentType;
  currencySign: string | undefined;
};

const ReceiptAndPaymentReceiptTableData = ({
  tableHeaders,
  data,
  currencySign,
}: AppProps) => {
  let openingData: ReceiptAndPaymentReceiptOpeningBalanceType[] =
    data?.receipt?.opening_balance;
  let othersData: ReceiptAndPaymentReceiptOtherType[] =
    data?.receipt?.others_data;
  let revenuesData: ReceiptAndPaymentRevenuesType[] =
    data?.receipt?.revenues_data;

  let gstReceivableData: ReceiptAndPaymentGstReceivableType[] =
    data?.receipt?.gst_receivable_data;

  let tDSData: ReceiptAndPaymentTDSDataType[] = data?.receipt?.tds_data;
  let revenueDeatilsData: ReceiptAndPaymentRevenuesDetailsType[] =
    data?.receipt?.revenues_item_details;

  openingData =
    openingData?.length > 0
      ? openingData?.filter(
          (el: ReceiptAndPaymentReceiptOpeningBalanceType) =>
            el?.opening_balance !== 0
        )
      : [];
  othersData =
    othersData?.length > 0
      ? othersData?.filter(
          (el: ReceiptAndPaymentReceiptOtherType) => el?.amount !== 0
        )
      : [];

  revenueDeatilsData =
    revenueDeatilsData?.length > 0
      ? revenueDeatilsData?.filter(
          (el: ReceiptAndPaymentRevenuesDetailsType) => el?.total_value !== 0
        )
      : [];
  revenuesData =
    revenuesData?.length > 0
      ? revenuesData?.filter(
          (el: ReceiptAndPaymentRevenuesType) => el?.balance !== 0
        )
      : [];

  return (
    <>
      <tr>
        <td
          style={{
            fontSize: "17px",
            fontWeight: 600,
            textDecoration: "underline",
          }}
        >
          OPENING BALANCE
        </td>
        <td style={{ fontSize: "16px", fontWeight: 500 }}>
          {currencySignAndNegativeValueAdjust(
            currencySign,
            data?.receipt?.total_opening_balance?.toString()
          )}
        </td>
      </tr>
      {openingData &&
        openingData?.length > 0 &&
        openingData?.map(
          (itemData: ReceiptAndPaymentReceiptOpeningBalanceType, i: number) => {
            return (
              <tr key={i}>
                {tableHeaders?.map((item: TableHeadersType) => {
                  if (item?.value === "account_name") {
                    return <td>{itemData?.ledger_name}</td>;
                  } else if (item?.value === "amount") {
                    return (
                      <td>
                        {currencySignAndNegativeValueAdjust(
                          currencySign,
                          itemData?.opening_balance?.toString()
                        )}
                      </td>
                    );
                  }
                })}
              </tr>
            );
          }
        )}
      <tr style={{ background: "#f4f6f8" }}>
        <td></td>
        <td></td>
      </tr>

      {revenueDeatilsData && revenueDeatilsData?.length > 0
        ? revenueDeatilsData?.map(
            (itemData: ReceiptAndPaymentRevenuesDetailsType, i: number) => {
              return (
                <tr key={i}>
                  {tableHeaders?.map((item: TableHeadersType) => {
                    if (item?.value === "account_name") {
                      return <td>{itemData?.ledger_name}</td>;
                    } else if (item?.value === "amount") {
                      return (
                        <td>
                          {currencySignAndNegativeValueAdjust(
                            currencySign,
                            itemData?.total_value?.toString()
                          )}
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            }
          )
        : ""}

      {othersData && othersData?.length > 0
        ? othersData?.map(
            (itemData: ReceiptAndPaymentReceiptOtherType, i: number) => {
              return (
                <tr key={i}>
                  {tableHeaders?.map((item: TableHeadersType) => {
                    if (item?.value === "account_name") {
                      return <td>{itemData?.ledger_name}</td>;
                    } else if (item?.value === "amount") {
                      return (
                        <td>
                          {/* {" "} */}
                          {currencySignAndNegativeValueAdjust(
                            currencySign,
                            itemData?.amount?.toString()
                          )}
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            }
          )
        : ""}
      {gstReceivableData && gstReceivableData?.length > 0 ? (
        <>
          {gstReceivableData[0]?.cgst_total_value !== 0 ? (
            <tr>
              <td>{gstReceivableData[0]?.cgst_ledger_name}</td>
              <td>
                {currencySignAndNegativeValueAdjust(
                  currencySign,
                  gstReceivableData[0]?.cgst_total_value?.toString()
                )}
              </td>
            </tr>
          ) : (
            ""
          )}
          {gstReceivableData[0]?.igst_total_value !== 0 ? (
            <tr>
              <td>{gstReceivableData[0]?.igst_ledger_name}</td>
              <td>
                {currencySignAndNegativeValueAdjust(
                  currencySign,
                  gstReceivableData[0]?.igst_total_value?.toString()
                )}
              </td>
            </tr>
          ) : (
            ""
          )}
          {gstReceivableData[0]?.sgst_total_value !== 0 ? (
            <tr>
              <td>{gstReceivableData[0]?.sgst_ledger_name}</td>
              <td>
                {currencySignAndNegativeValueAdjust(
                  currencySign,
                  gstReceivableData[0]?.sgst_total_value?.toString()
                )}
              </td>
            </tr>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}

      {tDSData && tDSData?.length > 0 ? (
        <>
          {tDSData[0]?.tds_total_value !== 0 ? (
            <tr>
              <td>{tDSData[0]?.tds_ledger_name}</td>
              <td>
                {currencySignAndNegativeValueAdjust(
                  currencySign,
                  tDSData[0]?.tds_total_value?.toString()
                )}
              </td>
            </tr>
          ) : (
            ""
          )}
        </>
      ) : (
        ""
      )}
      {/* commented for future use */}
      {/* {tdsGstReceivableData && tdsGstReceivableData?.length > 0
        ? tdsGstReceivableData?.map(
            (itemData: ReceiptAndPaymentTDSReceivableType, i: number) => {
              return (
                <tr key={i}>
                  {tableHeaders?.map((item: TableHeadersType) => {
                    if (item?.value === "account_name") {
                      return <td>{itemData?.ledger_name}</td>;
                    } else if (item?.value === "amount") {
                      return (
                        <td>
                          {currencySignAndNegativeValueAdjust(
                            currencySign,
                            itemData?.receivable_amount
                              ? itemData?.receivable_amount?.toString()
                              : itemData?.payble_amount?.toString()
                          )}
                         
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            }
          )
        : ""} */}
      {revenuesData?.length > 0 ? (
        <tr style={{ fontWeight: 700 }}>
          <td style={{ fontSize: "18px", textDecoration: "underline" }}>
            Less:
          </td>
          <td></td>
        </tr>
      ) : (
        ""
      )}
      {revenuesData && revenuesData?.length > 0
        ? revenuesData?.map(
            (itemData: ReceiptAndPaymentRevenuesType, i: number) => {
              return (
                <tr key={i} style={{ fontStyle: "italic", fontWeight: 600 }}>
                  {tableHeaders?.map((item: TableHeadersType) => {
                    if (item?.value === "account_name") {
                      return (
                        <td style={{ color: "#a1aabb" }}>
                          <span className="ml-5">{itemData?.ledger_name}</span>
                        </td>
                      );
                    } else if (item?.value === "amount") {
                      return (
                        <td style={{ color: "#a1aabb" }}>
                          {/* {" "} */}
                          {currencySignAndNegativeValueAdjust(
                            currencySign,
                            itemData?.balance?.toString()
                          )}
                        </td>
                      );
                    }
                  })}
                </tr>
              );
            }
          )
        : ""}

      <tr style={{ background: "#f4f6f8" }}>
        <td>
          <span style={{ fontSize: "17px", fontWeight: 600 }}>
            TOTAL<br></br>
          </span>
          (INCLUDING OPENING BALANCE AND OTHER TRANSACTIONS)
        </td>
        <td>
          <strong>
            {" "}
            {currencySignAndNegativeValueAdjust(
              currencySign,
              data?.receipt?.receipt_total?.toString()
            )}
          </strong>
        </td>
      </tr>
    </>
  );
};

export default ReceiptAndPaymentReceiptTableData;
